export default {
  title: '船舶数据管理',

  // 搜索筛选区域
  search: {
    keyword: '关键词搜索',
    keywordPlaceholder: '船舶名称、IMO号、呼号',
    shipType: '船舶类型',
    shipTypePlaceholder: '选择船舶类型',
    country: '国家',
    countryPlaceholder: '选择国家',
    status: '状态',
    statusPlaceholder: '选择状态',
    allStatus: '全部状态',
    enabled: '启用',
    disabled: '禁用',
    searchButton: '搜索',
    resetButton: '重置'
  },

  // 操作按钮
  actions: {
    addShip: '新增船舶',
    selectFromLibrary: '从库中选择',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    edit: '编辑',
    enable: '启用',
    disable: '禁用',
    recordsCount: '共 {count} 条记录'
  },

  // 表格列
  table: {
    shipName: '船舶名称',
    imoNumber: 'IMO号',
    shipType: '船舶类型',
    flag: '国家',
    callSign: '呼号',
    capacity: '载重吨',
    builtYear: '建造年份',
    owner: '船东',
    status: '状态',
    operation: '操作'
  },

  // 表单
  form: {
    addTitle: '新增船舶',
    editTitle: '编辑船舶',
    shipName: '船舶名称',
    shipNamePlaceholder: '请输入船舶名称',
    imoNumber: 'IMO号',
    imoNumberPlaceholder: '请输入IMO号',
    imoNumberHint: '必须为7位数字',
    shipType: '船舶类型',
    shipTypePlaceholder: '选择船舶类型',
    flag: '国家',
    flagPlaceholder: '请选择国家',
    callSign: '呼号',
    callSignPlaceholder: '请输入呼号',
    capacity: '载重吨',
    capacityPlaceholder: '请输入载重吨',
    builtYear: '建造年份',
    builtYearPlaceholder: '请输入建造年份',
    owner: '船东',
    ownerPlaceholder: '请输入船东',
    status: '状态',
    statusPlaceholder: '选择状态'
  },

  // 船舶类型
  shipTypes: {
    container: '集装箱船',
    bulk: '散货船',
    tanker: '油轮',
    general: '杂货船',
    roro: '滚装船',
    other: '其他'
  },

  // 选择弹窗
  modal: {
    title: '选择船舶',
    confirmText: '确认添加 ({count})',
    selected: '已选择 {count} 艘船舶，共 {total} 艘可选'
  },

  // 确认对话框
  confirm: {
    enableItem: '确定要启用此船舶吗？',
    disableItem: '确定要禁用此船舶吗？',
    batchEnable: '确定要启用选中的 {count} 艘船舶吗？',
    batchDisable: '确定要禁用选中的 {count} 艘船舶吗？'
  },

  // 表单验证
  validation: {
    shipNameRequired: '请输入船舶名称',
    shipNameMinLength: '船舶名称至少需要2个字符',
    shipNameMaxLength: '船舶名称不能超过100个字符',
    imoNumberRequired: '请输入IMO号(必须为7位数字)',
    imoNumberFormat: 'IMO号必须是7位数字',
    shipTypeRequired: '请选择船舶类型',
    capacityRequired: '请输入载重吨',
    builtYearRequired: '请输入建造年份',
    callSignRequired: '请输入呼号',
    callSignMinLength: '呼号至少需要3个字符',
    callSignMaxLength: '呼号不能超过10个字符',
    callSignFormat: '呼号只能包含字母和数字',
    flagRequired: '请选择国家',
    selectItems: '请选择要关联的船舶',
    checkRequired: '请填写所有必填字段'
  },

  // 消息提示
  messages: {
    selectToEnable: '请选择要启用的船舶',
    selectToDisable: '请选择要禁用的船舶',
    selectToAssociate: '请选择要关联的船舶',
    loadError: '船舶数据加载失败，请稍后重试',
    apiNotFound: '船舶数据接口不存在，请联系管理员',
    serverError: '服务器内部错误，请稍后重试',
    platformLoadError: '平台船舶数据加载失败，请稍后重试',
    saveSuccess: '船舶保存成功',
    saveError: '保存失败，请稍后重试',
    updateSuccess: '船舶更新成功',
    updateError: '更新失败，请稍后重试',
    checkRequired: '请填写所有必填字段',
    associateSuccess: '成功关联 {count} 艘船舶',
    associateError: '关联失败，请稍后重试',
    statusToggleSuccess: '船舶已{status}',
    statusToggleError: '状态切换失败，请稍后重试',
    batchEnableSuccess: '已启用 {count} 艘船舶',
    batchEnableError: '批量启用失败，请稍后重试',
    batchDisableSuccess: '已禁用 {count} 艘船舶',
    batchDisableError: '批量禁用失败，请稍后重试'
  },

  // 状态文本
  statusText: {
    enabled: '启用',
    disabled: '禁用'
  },

  // 国家选项
  countries: {
    CHN: '中国',
    PAN: '巴拿马',
    LBR: '利比里亚',
    SGP: '新加坡',
    MHL: '马绍尔群岛',
    HKG: '中国香港',
    MLT: '马耳他',
    CYP: '塞浦路斯',
    BHS: '巴哈马'
  }
}